module.exports = __webpack_public_path__ + "static/media/blank-profile-picture.b911cd34.png";